function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpperBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.42 132.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M89.36,132.54c-.32-.81-.84-1.59-.91-2.4-.13-1.98-.06-3.96-.03-5.93,0-1.91,.45-2.33,2.4-2.33h6.26V16.31h-7.46c-.13-2.53-.23-4.93-.36-7.52h10.77c3.18,0,4.54,1.39,4.54,4.57V121.84h6.26c2.21,0,2.56,.36,2.56,2.53,0,1.95-.03,3.89,.03,5.84,.03,.97-.23,1.78-1.04,2.33h-23.03Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.05,132.54c-.36-.75-.94-1.46-.97-2.21-.13-2.11-.06-4.22-.03-6.32,0-1.65,.49-2.14,2.17-2.14,2.14-.03,4.28,0,6.62,0V13.75c0-3.73,1.23-4.93,4.96-4.93h10.38c-.13,2.5-.23,4.9-.36,7.43h-7.43V121.87h6.55c1.62,.03,2.11,.49,2.14,2.08,.03,2.14,.1,4.31-.03,6.45-.03,.75-.58,1.43-.91,2.14-7.72,0-15.4,0-23.09,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.99,29.77c-3.37-.19-6.65-.39-9.92-.55-.81-.03-1.65-.06-2.46-.16-2.89-.32-4.38-2.11-4.25-4.99,.19-4.73,.42-9.47,.62-14.24,.13-2.79,2.01-4.61,4.61-4.48,2.46,.1,4.22,2.17,4.12,4.86-.1,2.4-.23,4.83-.32,7.23-.03,.97,0,1.98,0,3.02,13.52,1.56,27.08,1.56,40.73,0,0-.62,.03-1.3,0-1.95-.13-2.72-.26-5.42-.39-8.14-.1-2.89,1.62-4.96,4.22-5.03,2.63-.06,4.44,1.82,4.54,4.73,.16,4.61,.39,9.21,.55,13.85,.13,3.24-1.33,4.93-4.57,5.16-3.6,.26-7.23,.42-10.86,.62-.42,.03-.84,.06-1.36,.1-.03,.49-.06,.91-.06,1.3v24.84c0,.68,.13,1.36,.36,2.01,1.52,4.12,3.08,8.24,4.7,12.32,1.1,2.76,.62,5.12-1.46,7.23-.88,.88-1.72,1.82-2.66,2.79-3.18-2.11-6.32-4.18-9.47-6.26,.03-.16,.03-.29,.06-.32,1.88-1.3,1.78-2.85,.88-4.77-.88-1.82-1.52-3.76-2.17-5.68-.26-.78-.65-1.01-1.46-1.1-1.98-.26-3.24,.45-4.35,2.14-1.59,2.46-3.44,4.73-5.29,7.2,.45,.32,.88,.62,1.26,.88,5.93,3.92,11.87,7.82,17.8,11.77,3.28,2.17,3.96,5.93,1.62,8.69-1.69,2.01-4.44,2.56-6.81,1.43-.49-.26-.97-.55-1.46-.84-7.65-5.06-15.34-10.12-22.99-15.18-3.76-2.5-4.35-5.71-1.69-9.34,2.43-3.31,4.9-6.58,7.33-9.89,.32-.42,.58-1.01,.58-1.49,.03-9.05,.03-18.13,.03-27.18,.1-.13,.03-.29,0-.58Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.81,9.76C46.94,4.28,51.41-.1,56.8,0c5.51,.1,9.89,4.64,9.76,10.12-.13,5.38-4.61,9.76-9.92,9.7-5.48-.06-9.92-4.64-9.83-10.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.97,89.35c3.24,2.14,6.39,4.22,9.7,6.39-1.88,1.91-3.53,3.86-5.45,5.48-2.08,1.78-5.35,1.43-7.3-.52s-2.3-5.06-.58-7.3c1.07-1.39,2.37-2.66,3.63-4.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.71,8.82h2.17v7.36h-3.7c.49-2.37,1.01-4.77,1.52-7.36Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.18,16.18h-3.7v-7.33h2.24c.49,2.46,.97,4.86,1.46,7.33Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpperBody);
export default __webpack_public_path__ + "static/media/upperBody.8bc464a2ca9ceba06a5c2c59dd6cb188.svg";
export { ForwardRef as ReactComponent };